angular.module('rjmNg.directives').directive "shareDashboard", [
  () ->
    restrict: "E"
    templateUrl: "directive.shareDashboard.html"
    replace: true
    bindToController: true
    controllerAs: 'view'
    scope:
      canEditDashboard: "="
      unshareDashboard: "="
      popView: "="
    controller: [
      "$http"
      "dashboardService"
      "app"
      "$url"
      "enums"
      (
        $http
        dashboardService
        app
        $url
        enums
      ) ->
        view = @
        # Get a list of all the users on the client who share this dashboard
        _getUserList = () ->

          view.loading = true

          # Load the share list
          dashboardService.getShareList().then(
            (result) -> _handleSuccess(result),
            (error) -> _handleError(error)
          )

        _handleSuccess = (result) ->
          # Clear any errors
          view.error = ''

          # Client data
          clientData =
            type: 'client'
            permission: result.client
            name: app.getClientName()
            description: "Can be found by users in your organization"

          # Set user permissions values for the returns results
          user.permission = enums.DASHBOARD_PERMISSION.NONE for user in result.available
          user.permission = enums.DASHBOARD_PERMISSION.VIEW for user in result.view
          user.permission = enums.DASHBOARD_PERMISSION.EDIT for user in result.edit

          # Only show the available list if I'm the owner
          if view.canEditDashboard
            # Add the arrays together
            view.users = result.view.concat result.edit.concat result.available

            for user in view.users
              if user.g_type is 'access-group'
                  user.type = 'access-group'
              else if user.type is 'client'
                  user.type = 'client'
              else
                  user.type = 'user'

            if app.hasFeatureFlag('DASHBOARD_DISCOVERY')
              view.users.unshift clientData

            # See which users are available to share this dashboard to and filter out the owner
            view.users = view.users.filter (user) ->
              user.id isnt dashboardService.dashboard.userId

          else
            view.users = result.view.concat result.edit
            view.shareCount = view.users.length

          user.selected = false for user in view.users

          # Remember this so we can look for changes
          view.originalUserSelections = view.users.map (user) -> user.permission
          view.disableShare = true

          view.loading = false

        _handleError = (error) ->
          view.loading = false
          view.status = ''
          view.error = "There was an error retrieving your dashboard's share list. Close this popover and try again.  If that doesn't work, please contact support."

        # Share a dashboard with a list of users
        view.shareDashboard = () ->
          view.loading = true
          view.error = ''
          view.status = "Sharing..."

          users = angular.copy(view.users)

          # Pick out the client since this will get a separate request
          client = null
          for user in users when user.type is 'client'
            client = users.splice( users.indexOf(user), 1)
            break

          # Only passed in selected users
          users = users.filter (user) -> user.permission

          clientRequest = angular.extend dashboardService.dashboard

          if client?
            clientRequest.clientPermission = client[0].permission

          dashboardService.save(clientRequest)

          $http(
            method: 'POST'
            url: $url("/client/#{app.getClientId()}/dashboard/#{dashboardService.dashboard.id}/share")
            data: users
          )
          .then( (response) ->
            view.error = ''
            view.status = 'Sharing complete!'

            # Remember this so we can look for changes
            view.originalUserSelections = users.map (user) -> user.permission
            view.disableShare = true
            view.loading = false

          )
          .catch( (error) ->
            view.loading = false
            view.status = ''
            view.error = "There was an error submitting your list of users. Please try again. If the problem continues, contact support."
          )

        view.close = () ->
          view.popView.hide()

        view.onToggle = () ->
          view.disableShare = _.isEqual(view.originalUserSelections, view.users.map (user) -> user.permission)
          selected = view.users.filter (user) -> user.selected
          view.selectCount = selected.length

        view.leaveDashboard = () ->
          view.popView.hide()
          view.unshareDashboard()

        # General variables
        view.users = []
        view.isOwner = not dashboardService.dashboard.is_syndicated

        view.initialize = () ->
          view.selectCount = 0
          view.originalUserSelections = []
          view.error = ''
          view.status = ''
          view.disableShare = true
          _getUserList()

        view
    ]
    link: (scope, element, attr, view) ->

      scope.$watch 'view.popView.visible', (newVisible, oldVisible) ->
        if newVisible and newVisible isnt oldVisible
          view.initialize()

]
